import { useState } from "react";
import { Box, Tabs, Tab, Paper } from "@mui/material";

import BookingBullion from "./BookingBullion";
import BookingTransaction from "./BookingTransaction";
import BookingReport from "./BookingReport";
import { canShowPermission } from "../Permissions/permissionObject";
import { useEffect } from "react";
import InfoButton from "../../Comman/InfoButton";

export default function BookingBullionPage() {
  const [tabIndex, setTabIndex] = useState(0);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const canViewBookingTransaction = canShowPermission(
    permissions,
    "bookingTransaction",
    "view",
  );
  const canViewBookingBullion = canShowPermission(
    permissions,
    "bookingBullion",
    "view",
  );
  const canViewBookingReport = canShowPermission(
    permissions,
    "bookingReport",
    "view",
  );

  const tabs = [
    canViewBookingTransaction && {
      label: "Booking Transactions",
      content: <BookingTransaction />,
    },
    canViewBookingBullion && {
      label: "Booking Requests",
      content: <BookingBullion />,
    },
    canViewBookingReport && {
      label: "Booking Report",
      content: <BookingReport />,
    },
  ];

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
        <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Paper
          sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }}
          elevation={1}
        >
          {/* Tabs */}
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              padding: "4px",
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "16px",
                textTransform: "none",
                borderRadius: "6px",
                margin: "0 4px",
                minHeight: "48px",
                "&.Mui-selected": {
                  backgroundColor: "#fff",
                  color: "#7A3FFF",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  borderBottom: "3px solid #7A3FFF",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>

          {/* Tab Content */}
          <Box sx={{ mt: 2 }}>{tabs[tabIndex]?.content}</Box>
        </Paper>
      </Box>
      <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="BOOKING_BULLION" />
  </Box>
      </Box>
    </Box>
  );
}
